<template>
  <li class="card ticket" @click="updateValue(value)" :class="modelValue === value ? 'on ' : ''">
    <!--    MEMO: 기존에 isCouple 타입에 따라 노출 달랐음 -->
    <!--    <span v-if="!isShop" class="badge" :class="canUse ? 'primary' : 'red'">{{ canUse ? '이용가능' : '이용불가' }}</span>-->
    <div class="title-wrap">
      <h3 class="title">{{ title ?? '가입 1회 무료 이용권' }}</h3>

      <p class="price" v-if="isBenefit">{{ item.count }}개</p>
      <p class="price" v-if="price">{{ user.isPremium ? toDot(price) + 'P' : toDot(price) + '원' }}</p>
    </div>
    <!--<div class="info-txt" v-if="value?.productCode && value.productCode.includes('B_PASS')">-->
    <!--  <p>교회,기독교 묘원 및 단체</p>-->
    <!--</div>-->
    <p class="date" v-if="paymentDate">구매일: {{ toLocalDate2(paymentDate) }}</p>

    <div class="writer-wrap" v-if="paymentDate && expiredDate">
      <p class="date">구매일: {{ paymentDate }}</p>
      <p class="date">만료일: {{ expiredDate }}</p>
    </div>
  </li>
</template>
<script setup>
import { toDot, toLocalDate2 } from '@/common/utils/module/FormattingSupport';
import { computed } from 'vue';
import store from '@/store';

const user = computed(() => store.getters['user/getUserData']);

const emits = defineEmits(['update:modelValue']);
const props = defineProps({
  item: {
    type: Object,
    default: null
  },
  title: {
    type: String,
    default: ''
  },
  price: {
    type: [Number, String],
    default: null
  },
  regDate: {
    type: String,
    default: ''
  },
  expiredDate: {
    type: String,
    default: ''
  },
  value: {
    type: [Number, String, Object],
    default: null
  },
  state: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: [Number, String, Object],
    default: ''
  },
  isShop: {
    type: Boolean,
    default: true
  },
  isReSelect: {
    type: Boolean,
    default: true
  },
  isBenefit: {
    type: Boolean,
    default: false
  },
  paymentDate: {
    type: String,
    default: ''
  },
  canUse: {
    type: Boolean,
    default: true
  }
});

const updateValue = itemHistoryNo => {
  if (!props.canUse) return;
  if (props.modelValue === itemHistoryNo && props.isReSelect) {
    emits('update:modelValue', '');
  } else {
    emits('update:modelValue', itemHistoryNo);
  }
};
</script>

<style scoped></style>
